<template>
  <div v-loading.body="loading">
    <div
      v-if="resData"
      class="row"
      :gutter="20"
      type="flex"
      align="middle"
      justify="start"
    >
      <div
        v-for="item in stockStoreList"
        v-if="item.key !== -1"
        :key="item.key"
        class="status"
        :class="{ active: form.storehouse_id === item.key }"
        @click="selectOrigin(item.key)"
      >
        {{ item.label }}
      </div>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="无数据ID">
                  <el-input
                    v-model="form.ndg_id"
                    placeholder="无数据ID"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="商家">
                  <el-input
                    v-model="form.supply_name"
                    placeholder="商家"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="包裹类型">
                  <el-select
                    v-model="form.package_type"
                    placeholder="包裹类型"
                    style="width: 150px"
                    clearable
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in constantMap.packageTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否异常">
                  <el-select
                    v-model="form.status"
                    placeholder="是否异常"
                    style="width: 150px"
                    clearable
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in constantMap.statusOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="分播类型">
                  <el-select
                    v-model="form.type"
                    placeholder="分播类型"
                    style="width: 150px"
                    clearable
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in constantMap.typeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="分播时间：">
                  <el-date-picker
                    v-model="form.created_at"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item>
                  <el-button type="" @click="reset">重置</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="success" @click="exportExcel">
                    导出
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="ndgid"
              label="无数据ID"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="supply_name"
              label="商家"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="no_data_reason_txt"
              label="无数据理由"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="package_type_txt"
              label="包裹类型"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="type_txt"
              label="分播类型"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="create_admin_name"
              label="分播人"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="grid_no"
              label="格口号"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="exception_reason"
              label="异常原因"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="created_at"
              label="分播时间"
            ></el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.total"
            :page-size="form.page_size"
            :page-sizes="[50, 100, 200, 500, 1000]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";
import { postNoDataIdCutLog } from "@/openapi/erp/deviceCut.js";

const constantMap = Object.freeze({
  packageTypeOptions: [
    { label: "大货", value: "1" },
    { label: "备货", value: "2" },
    { label: "前置仓", value: "3" },
  ],
  statusOptions: [
    { label: "正常", value: "1" },
    { label: "异常", value: "2" },
  ],
  typeOptions: [
    { label: "按波次单", value: "1" },
    { label: "按采购组", value: "2" },
    { label: "按供应商", value: "3" },
    { label: "按汇总单", value: "4" },
    { label: "入库分播", value: "5" },
    { label: "按次品员", value: "6" },
    { label: "按中分位", value: "7" },
    { label: "波次粗分", value: "8" },
    { label: "按退供员", value: "9" },
    { label: "按中分位分组", value: "10" },
  ],
});

export default {
  props: {
    stockStoreList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      constantMap,
      images: [],
      showbox: false,
      fileList: [],
      resData: {},
      form: {
        page_size: 50,
        created_at: this.$excalibur.getDateTimeOnHours(-6, 6),
        storehouse_id: 1,
      },
      storehouseIds: [],
      space: "",
      ss_id: 0,
      loading: false,
      tableLoading: false,
      curPage: 1,
      filterFold: false,
      isAll: false,
      searchOptions: null,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    showImages(img) {
      this.showbox = true;
      this.images = img;
    },
    closeBox() {
      this.showbox = false;
    },
    selectOrigin(originId) {
      this.form.storehouse_id = originId;
      this.fetchData(true);
    },

    exportExcel() {
      this.form.export = 1;
      postNoDataIdCutLog(this.filteredForm)
        .then((res) => {
          if (res.file) {
            this.form.export = 0;
            window.open(apiBaseURL + res.file);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      postNoDataIdCutLog(this.filteredForm)
        .then((res) => {
          this.resData = res;
        })
        .finally(() => {
          this.loading = false;
          this.tableLoading = false;
        });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.fetchData();
    },
    handleSizeChange(val) {
      this.form.page_size = val;
      this.fetchData(true);
    },

    search() {
      this.form.page = 1;
      this.loading = true;
      this.form.is_excel = 0;
      this.fetchData(true);
    },

    trim(str, is_global) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    reset() {
      this.search_value = "";
      this.form = {};
      this.form.page = 1;
      this.form.page_size = 50;
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/devicecut/components/NoDataCutLog.vue